module.exports = "/images/modal-close.png?c4c366d17889dcb14da2df1aa2d8ec97";